export const ANALYTICS_EVENTS = {
	HOME_LINK: 'home_event',
	LOGIN: 'login',
	SIGNUP: 'sign_up',
	ONBOARDING: 'onboarding_event',
	ADD_RFC: 'add_rfc',
	ADD_TO_CART: 'add_to_cart',
	PURCHASE: 'purchase',
	PAID_CUSTOMER_CHARGED: 'paid_customer_charged',
	/** Conversión atribuible a una red de AFILIADOS (Affise/Admattic): se
	 * dispara solo cuando hay un clic de afiliado guardado. Existe aparte de
	 * `purchase` porque es la pieza con la que se CONCILIA la factura del
	 * afiliado contra nuestra base antes de pagarles — lleva el click id, así
	 * que cada línea de su reporte tiene contraparte exacta del lado nuestro.
	 * Ver shared/attribution/affiliate.ts. */
	AFFILIATE_CONVERSION: 'affiliate_conversion',
	PLANS: 'plans_event',
	CHARGED: 'Charged',
	CHECKOUT: 'checkout_event',
	INVOICE_HOME_INVOICES: 'home_invoices',
	INVOICE_FISRT_STEP_DATA: 'fisrt_step_data',
	INVOICE_SECOND_STEP_PRODUCT: 'second_step_product',
	INVOICE_THIRD_STEP_VALIDATION: 'third_step_validation',
	INVOICE_CONFIRMATION_STEP: 'confirmation_step',
	INVOICE_INVOICE_DETAILS: 'Invoice_details',
	TAX_DASHBOARD: 'tax_dashboard_event',
	TAXBOARD_DASHBOARD: 'tax_dashboard_event',
	PAGE_VIEWED: 'Page_Viewed',
	FISCAL_DOCUMENTS: 'fiscal_documents_event',
	RAPPI_CERTIFICATES: 'Rappi_certifications_event',
	// t-152: deep-link de campaña a Certificados. `opened` al abrir el enlace
	// (antes de auth); `completed` al aterrizar en Certificados con sesión.
	CERT_DEEPLINK_OPENED: 'cert_deeplink_opened',
	CERT_DEEPLINK_COMPLETED: 'cert_deeplink_completed',
	CONFIRM_ACCOUNT_DELETED: 'Confirm_account_deleted',
	PLAN_CTA_CLICKED: 'plan_cta_clicked',
	PLAN_CARD_CLICKED: 'plan_card_clicked',
	//? Approval Declarations
	APPROVAL_DECLARATIONS: 'product_interaction_approval_declaration',
	//? Regularization Flow
	REGULARIZATION_FLOW: 'product_interaction_regularization_flow',
	//? Pages Views
	PAGE_VIEW: 'page_view',
	//? NSS
	NSS_VALIDATION: 'nss_validation',
	IMSS_SECTION_TAB_NSS: 'imss_section_tab_nss',
	IMSS_SECTION_TAB_REGULARIZATION: 'imss_section_tab_regularization',
	//? Notifications
	NOTIFICATION_OPEN: 'notification_open',
	NOTIFICATION_INTERACTED: 'notification_interacted',
	NOTIFICATION_CHECKED: 'notification_checked',
	NOTIFICATION_FAILURE_IDENTIFIED: 'notification_failure_identified',
	NOTIFICATION_WEB_ACCEPTED: 'notification_web_accepted',
	NOTIFICATION_WEB_DENIED: 'notification_web_denied',
	NOTIFICATION_WEB_TOGGLED: 'notification_web_toggled',
	LOGOUT: 'logout',
	APP_ERROR_VIEWED: 'app_error_viewed',
	//? t-215: foto de perfil del usuario. `source`: google | upload.
	PROFILE_PICTURE_UPLOADED: 'profile_picture_uploaded',
	PROFILE_PICTURE_UPLOAD_FAILED: 'profile_picture_upload_failed',
	PROFILE_PICTURE_REMOVED: 'profile_picture_removed',
	//? Wrapped
	WRAPPED_OPEN: 'wrapped_open',
	WRAPPED_CLOSE: 'wrapped_close',
	WRAPPED_STEPS: 'wrapped_steps',

};

export const EVENT_TYPES = {
	// Home Page
	HOME_MAIN_SCREEN_VIEWED: 'main_screen_viewed',
	HOME_LINK_ATTEMP: 'link_attempt',
	HOME_LINK_INTERACTION: 'link_interaction',
	HOME_TAX_PROFILE_SHARED: 'tax_profile_shared',
	HOME_TAX_DOCUMENTS_SHARED: 'tax_documents_shared',
	HOME_TAX_DOCUMENTS_DOWNLOADED: 'tax_documents_downloaded',
	HOME_TAX_STATUS_INTERACTION: 'tax_status_interaction',
	HOME_PURCHASE_BANNER_INTERACTION: 'purchase_banner_interaction',
	HOME_PENDING_PURCHASE_INTERACTION: 'pending_purchase_interaction',
	HOME_FISCAL_OBLIGATIONS_FILTER: 'fiscal_obligations_filter',
	HOME_VIEW_ALL_SERVICE_STATUS: 'view_all_service_status',
	HOME_SERVICE_STATUS_CTA: 'service_status_CTA',
	// Login Page
	LOGIN: 'login',
	SIGNUP: 'sign_up',
	SIGNUP_STEP_INTERACTED: 'signup_step_interacted',
	SIGNUP_FAILURE_IDENTIFIED: 'signup_failure_identified',
	SIGNUP_SUCCESS_COMPLETED: 'signup_success_completed',
	LOGIN_OTP_START_INITIATED: 'login_otp_start_initiated',
	LOGIN_OTP_STEP_INTERACTED: 'login_otp_step_interacted',
	LOGIN_OTP_SUCCESS_COMPLETED: 'login_otp_success',
	LOGIN_OTP_FAILURE_IDENTIFIED: 'login_otp_failure_identified',
	// Onboarding
	ONBOARDING_FIRST_STEP: 'first_step',
	ONBOARDING_WELCOME: 'welcome_step',
	ONBOARDING_RECOMMENDATION_STEP: 'recommendation_step',
	ONBOARDING_ADD_PRODUCT: 'add_product',
	ONBOARDING_SKIP_ADD_PRODUCT: 'skip_add_product',
	ONBOARDING_EXIT_ADD_PRODUCT: 'exit_add_product',
	ONBOARDING_RESUME_ADD_PRODUCT: 'resume_add_product',
	ONBOARDING_LINK_CREDENTIALS: 'link_credentials',
	ONBOARDING_SKIP_LINK_CREDENTIALS: 'skip_link_credentials',
	ONBOARDING_EXIT_LINK_CREDENTIALS: 'exit_link_credentials',
	ONBOARDING_RESUME_LINK_CREDENTIALS: 'resume_link_credentials',
	ONBOARDING_HELP_LINK_CREDENTIALS: 'help_link_credentials',
	ONBOARDING_HELP_LINK_CREDENTIALS_ASAT: 'help_link_credentials_asat',
	ONBOARDING_HELP_LINK_CREDENTIALS_CREATE_PASSWORD:
		'help_link_credentials_create_password',
	ONBOARDING_HELP_LINK_CREDENTIALS_RECOVER_PASSWORD:
		'help_link_credentials_recover_password',
	ONBOARDING_NO_SELLOS_DIGITALES_CLICKED: 'no_sellos_digitales_clicked',
	// Plans
	PLANS_TAB: 'plans_tab',
	PLANS_SELECT: 'plans_select',
	PLANS_ADD_TO_CART: 'add_to_cart',
	PLANS_ADD_TO_CART_COMM: 'add_to_cart_comm',
	// Invoicing
	INVOICE_GENERATE_NEW_INVOICE: 'generate_new_invoice',
	INVOICE_VIEW_DETAIL: 'view_detail',
	INVOICE_ASAT_PRODUCT_SHOPPING_CAR: 'asat_product_shopping_car',
	INVOICE_SAVE_STAMP: 'save_stamp',
	INVOICE_GO_BACK_STAMP: 'go_back_stamp',
	INVOICE_LINK_STAMP: 'link_stamp',
	INVOICE_USERS_INFORMATION: 'users_information',
	INVOICE_PRODUCT_INFORMATION: 'product_information',
	INVOICE_ADD_PRODUCT: 'add_product',
	INVOICE_DELETE_PRODUCT: 'delete_product',
	INVOICE_CONFIRM_DELETE_PRODUCT: 'confirm_delete_product',
	INVOICE_BACK_DELETE_PRODUCT: 'back_delete_product',
	INVOICE_EDIT_PRODUCT: 'edit_product',
	INVOICE_EDIT_RECEIVER: 'edit_receiver',
	INVOICE_PREVIEW: 'invoice_preview',
	INVOICE_REVIEW_COMPLETED: 'review_completed',
	INVOICE_ADD_EMAIL: 'add_email',
	INVOICE_SEND_CONFIRMATION: 'send_confirmation',
	INVOICE_DOWNLOAD_PDF: 'download_pdf',
	INVOICE_DOWNLOAD_XML: 'download_xml',
	INVOICE_RESEND: 'resend',
	INVOICE_CANCEL: 'cancel',
	INVOICE_CONFIRM_CANCELLATION: 'confirm_cancellation',
	// Tax Dashboard
	TAXBOARD_VIEW_DASHBOARD: 'view_dashboard',
	TAXBOARD_SELECT_DASHBOARD: 'select_dashboard',
	TAXBOARD_MAIN_CTA_SELECTED: 'main_cta_selected',
	TAXBOARD_GROUP_TAX_SELECTED: 'group_tax_selected',
	TAXBOARD_TAX_CTA_SELECTED: 'tax_cta_selected',
	TAXBOARD_DETAIL_SELECTED: 'tax_detail_selected',
	TAXBOARD_SELECT_PERIODICITY: 'select_periodicity',
	TAXBOARD_SELECT_FILTER: 'select_filter',
	TAXBOARD_TAX_DETAIL_SELECTED: 'tax_detail_selected',
	TAXBOARD_TAX_RECEIPT_DOWNLOADED: 'tax_detail_receipt_downloaded',
	TAXBOARD_PERIOD_DETAIL_VIEWED: 'period_detail_viewed',
	TAXBOARD_ACQUIRE_PERIOD: 'acquire_period',
	TAXBOARD_VIEW_PERIOD_FISCAL_DOCUMENTS: 'view_period_fiscal_documents',
	TAXBOARD_DOCUMENT_DETAIL_OPENED: 'document_detail_opened',
	TAXBOARD_DOCUMENT_DOWNLOADED: 'document_downloaded',
	TAXBOARD_BANNER_SELECTED: 'banner_selected',
	// Fiscal Documents
	FISCAL_DOCUMENTS_VIEW_FISCAL_DOCUMENTS: 'view_fiscal_documents',
	FISCAL_DOCUMENTS_SELECT_FILTER: 'select_filter',
	FISCAL_DOCUMENTS_TAB: 'fiscal_document_tab',
	FISCAL_DOCUMENTS_DETAIL: 'detail',
	FISCAL_DOCUMENTS_DETAIL_ACTION: 'detail_action',
	// Rappi Certificates
	RAPPI_CERTIFICATES_VIEW: 'view_rappi_certifications',
	// Zubale Certificates
	ZUBALE_CERTIFICATES_VIEW: 'view_zubale_certifications',
	// Approval Declarations
	APPROVAL_DECLARATIONS_VIEW_DETAIL: '01_view_detail_and_approve',
	APPROVAL_DECLARATIONS_APPROVED_EXPENSE: '02_approved_income_and_retentions',
	APPROVAL_DECLARATIONS_APPROVED_DEDUCTIONS:
		'03_approved_expense_and_deductions',
	APPROVAL_DECLARATIONS_VIEW_DETAIL_DEDUCTIONS: '031_view_detail_deductions',
	APPROVAL_DECLARATIONS_OPEN_DROPDOWN_PERSONAL_DEDUCTIONS:
		'032_open_dropdown_personal_deductions',
	APPROVAL_DECLARATIONS_ABANDONED_FLOW_STEP_EXPENSES:
		'033_abandoned_approval_flow_step_expenses',
	APPROVAL_DECLARATIONS_APPROVED_DECLARATION: '04_approved_declaration',
	APPROVAL_DECLARATIONS_VIEW_DETAIL_CALCULATION: '041_view_detail_deductions',
	APPROVAL_DECLARATIONS_ABANDONED_FLOW_STEP_SUMMARY:
		'042_abandoned_approval_flow_step_summary',
	APPROVAL_DECLARATIONS_REVIEW_DECLARATION: '05_review',
	APPROVAL_DECLARATIONS_SEND_REVIEW: '051_send_review',
	APPROVAL_DECLARATIONS_AUTOMATIC_APPROVAL_BY_USER:
		'07_automatic_approval_by_user',
	APPROVAL_DECLARATIONS_MANUAL_APPROVAL_BY_USER: '071_manual_approval_by_user',
	// Approval Declarations Preview Flow
	APPROVAL_DECLARATIONS_PREVIEW_VIEW_INCOMES: '08_preview_view_incomes',
	APPROVAL_DECLARATIONS_PREVIEW_VIEW_EXPENSES: '081_preview_view_expenses',
	APPROVAL_DECLARATIONS_PREVIEW_VIEW_SUMMARY: '082_preview_view_summary',
	APPROVAL_DECLARATIONS_REPORT_MISSING_INCOME: '06_report_missing_income',
	APPROVAL_DECLARATIONS_REPORT_MISSING_EXPENSE: '061_report_missing_expense',
	APPROVAL_DECLARATIONS_OPEN_INVOICES_ACCORDION: '062_open_invoices_accordion',
	APPROVAL_DECLARATIONS_OPEN_DEDUCTIBLE_RULES: '063_open_deductible_rules',
	APPROVAL_DECLARATIONS_STEP_NEXT: '064_step_next',
	APPROVAL_DECLARATIONS_STEP_BACK: '065_step_back',
	APPROVAL_DECLARATIONS_OPEN_REVIEW_MODAL: '066_open_review_modal',
	APPROVAL_DECLARATIONS_REVIEW_REASON_SELECTED: '067_review_reason_selected',
	APPROVAL_DECLARATIONS_REVIEW_REASON_TYPED: '068_review_reason_typed',
	APPROVAL_DECLARATIONS_VIEW_INCOME_DETAIL: '069_view_income_detail',
	APPROVAL_DECLARATIONS_SWITCH_TAB: '070_switch_tab',
	APPROVAL_DECLARATIONS_EXPAND_CALCULATION: '072_expand_calculation',
	APPROVAL_DECLARATIONS_SUPPORT_MESSAGE_TYPED: '073_support_message_typed',
	APPROVAL_DECLARATIONS_ACTION_FAILED: '074_action_failed',
	APPROVAL_DECLARATIONS_ACTION_SUCCEEDED: '075_action_succeeded',
	APPROVAL_DECLARATIONS_RENEW_SUBSCRIPTION: '083_renew_subscription',
	APPROVAL_DECLARATIONS_PREBILLING_OFFER_VIEWED: '084_prebilling_offer_viewed',
	APPROVAL_DECLARATIONS_PREBILLING_OFFER_CLICKED:
		'085_prebilling_offer_clicked',
	APPROVAL_DECLARATIONS_PREBILLING_COMPLETED: '086_prebilling_completed',
	APPROVAL_DECLARATIONS_STEPPER_NAVIGATE: '087_stepper_navigate',
	APPROVAL_DECLARATIONS_ABANDONED_FLOW_STEP_WELCOME:
		'088_abandoned_approval_flow_step_welcome',
	APPROVAL_DECLARATIONS_ABANDONED_FLOW_STEP_INCOMES:
		'089_abandoned_approval_flow_step_incomes',
	APPROVAL_DECLARATIONS_FAQ_OPENED: '090_faq_opened',
	APPROVAL_DECLARATIONS_STEP_VIEWED: '091_step_viewed',
	APPROVAL_DECLARATIONS_PREBILLING_MODAL_VIEWED:
		'092_prebilling_modal_viewed',
	APPROVAL_DECLARATIONS_PREBILLING_EXECUTE_CLICKED:
		'093_prebilling_execute_clicked',
	APPROVAL_DECLARATIONS_PREBILLING_FAILED: '094_prebilling_failed',
	APPROVAL_DECLARATIONS_PREBILLING_MODAL_CLOSED:
		'095_prebilling_modal_closed',
	APPROVAL_DECLARATIONS_PURCHASE_CTA_CLICKED: '096_purchase_cta_clicked',
	APPROVAL_DECLARATIONS_VIEW_EXPENSE_INVOICE_DETAIL:
		'097_view_expense_invoice_detail',
	APPROVAL_DECLARATIONS_DEDUCTIBILITY_TOGGLE_CLICKED:
		'098_deductibility_toggle_clicked',
	APPROVAL_DECLARATIONS_PPD_SECTION_VIEWED: '099_ppd_section_viewed',
	// Paquete "Ponte al día".
	PONTE_AL_DIA_VIEW_OFFER: '096_ponte_al_dia_view_offer',
	PONTE_AL_DIA_VIEW_DETAIL: '097_ponte_al_dia_view_detail',
	PONTE_AL_DIA_GO_TO_CHECKOUT: '098_ponte_al_dia_go_to_checkout',
	PONTE_AL_DIA_SPECIALIST: '099_ponte_al_dia_specialist',
	// The package's ONE exposure event, once per mount; the rest of the funnel
	// hangs off it.
	PONTE_AL_DIA_EXPERIENCE_VIEWED: '0992_ponte_al_dia_experience_viewed',
	PONTE_AL_DIA_QUESTION_ANSWERED: '0993_ponte_al_dia_question_answered',
	PONTE_AL_DIA_YEAR_TOGGLED: '0994_ponte_al_dia_year_toggled',
	PONTE_AL_DIA_LINK_SAT: '0995_ponte_al_dia_link_sat',
	PONTE_AL_DIA_DECLINE: '0996_ponte_al_dia_decline',
	PONTE_AL_DIA_NOTHING_TO_REGULARIZE: '0997_ponte_al_dia_nothing_to_regularize',
	PONTE_AL_DIA_QUOTE_FAILED: '0998_ponte_al_dia_quote_failed',
	// La confirmación de regímenes que el paquete no cotiza (Actividad
	// Empresarial, Arrendamiento, RIF) antes de ir al carrito.
	PONTE_AL_DIA_UNPRICED_CONFIRM_VIEWED: '0999_ponte_al_dia_unpriced_confirm_viewed',
	PONTE_AL_DIA_UNPRICED_CONFIRM_CHOICE: '09991_ponte_al_dia_unpriced_confirm_choice',
	// Banner de /planes que vende aparte los meses de Actividad Empresarial.
	PONTE_AL_DIA_BUSINESS_UPSELL_VIEWED: '09992_ponte_al_dia_business_upsell_viewed',
	PONTE_AL_DIA_BUSINESS_UPSELL_ADD_TO_CART: '09993_ponte_al_dia_business_upsell_add_to_cart',
	// Linked user whose debt can't be sold yet: "Estamos calculando tu adeudo"
	// (syncing) or "Reconecta tu SAT" (unavailable), with the reason.
	PONTE_AL_DIA_DEBT_NOT_READY: '09994_ponte_al_dia_debt_not_ready',
	// The "?" next to the estimate note opened its explanation drawer.
	PONTE_AL_DIA_ESTIMATE_INFO_OPENED: '09995_ponte_al_dia_estimate_info_opened',
	//? Pages Views
	PAGE_VIEW_HOME: 'home',
	PAGE_VIEW_ANNUAL_DECLARATION: 'annual_declaration',
	PAGE_VIEW_PLANS_AND_PRICES: 'plans_and_prices',
	PAGE_VIEW_TAXES_AND_INVOICES: 'taxes_and_invoices',
	PAGE_VIEW_SUPPORT: 'support',
	PAGE_VIEW_ZUBALE_CERTIFICATES: 'zubale_certificates',
	PAGE_VIEW_FISCAL_FLOW_TRANSACTIONS: 'fiscal_flow_transactions',
	PAGE_VIEW_SUPPORT_FORM: 'support_form',
	PAGE_VIEW_SERVICE_STATUS: 'service_status',
	PAGE_VIEW_REFACTOR_INVOICING: 'refactor_invoicing',
	PAGE_VIEW_RAPPI_CERTIFICATES: 'rappi_certificates',
	PAGE_VIEW_PROFILE: 'profile',
	PAGE_VIEW_ONBOARDING: 'onboarding',
	PAGE_VIEW_INTRO: 'intro',
	PAGE_VIEW_FISCAL_DOCUMENTS: 'fiscal_documents',
	PAGE_VIEW_AUTH: 'auth',
	PAGE_VIEW_SHOPPING: 'shopping',
	PAGE_VIEW_SUBSCRIPTION_DETAIL: 'subscription_detail',
	PAGE_VIEW_ACCOUNT_HERU: 'account_heru',
	PAGE_VIEW_PAYMENT_METHODS: 'payment_methods',
	PAGE_VIEW_UBER_FLOW: 'uber_flow',
	PAGE_VIEW_SUCCESSFUL_PURCHASE: 'successful_purchase',
	PAGE_VIEW_TAX_PROFILE: 'tax_profile',
	PAGE_VIEW_PENDING_REFERENCES: 'pending_references',
	//? Section Views
	SECTION_VIEW_LINKING_FORM: 'section_view_linking_form',
	//? NSS
	NSS_NEW_REGULATIONS: 'nss_new_regulations',
	NSS_VALIDATION_STARTED: 'nss_validation_started',
	//? Onboarding
	ONBOARDING_STEP_INTERACTED: 'onboarding_step_interacted',
	ONBOARDING_COMPLETED: 'onboarding_completed',
	//? Onboarding — funnel exit visibility. `abandoned` fires when a user leaves
	//? /onboarding-v2 without completing (exited && no completed_via).
	//? `redirect_loop_detected` fires ONCE when a step's view storms (a redirect
	//? loop) instead of emitting the storm as N views.
	ONBOARDING_FLOW_ABANDONED: 'onboarding_flow_abandoned',
	SAT_ID_FLOW_INITIATED: 'sat_id_flow_initiated',
	SAT_ID_STEP_INTERACTED: 'sat_id_step_interacted',
	SAT_ID_STEP_SUCCESS_COMPLETED: 'sat_id_step_success_completed',
	SAT_ID_STEP_FAILURE_IDENTIFIED: 'sat_id_step_failure_identified',
	SAT_ID_FLOW_SUCCESS_COMPLETED: 'sat_id_flow_success_completed',
	SAT_ID_FLOW_ABANDONED: 'sat_id_flow_abandoned',
	ONBOARDING_REDIRECT_LOOP_DETECTED: 'onboarding_redirect_loop_detected',
	//? Onboarding — Goals "Otra cosa" free-text classifier
	ONBOARDING_GOAL_OTHER_OPENED: 'onboarding_goal_other_opened',
	ONBOARDING_GOAL_OTHER_CLASSIFIED: 'onboarding_goal_other_classified',
	//? Onboarding — Guided-onboarding call scheduler (Cal.com embed)
	ONBOARDING_SCHEDULER_VIEWED: 'onboarding_scheduler_viewed',
	ONBOARDING_SCHEDULER_STARTED: 'onboarding_scheduler_started',
	ONBOARDING_SCHEDULER_BOOKED: 'onboarding_scheduler_booked',
	ONBOARDING_SCHEDULER_SKIPPED: 'onboarding_scheduler_skipped',
	ONBOARDING_CALL_JOIN_CLICKED: 'onboarding_call_join_clicked',
	//? Onboarding — CURP extraction (RFC generation sub-branch)
	LEGAL_DOCUMENT_OPENED: 'legal_document_opened',
	// Denominador del funnel del modal de re-consentimiento: una emisión por
	// apertura real del modal. Aceptación / posposición se leen contra
	// LEGAL_DOCUMENT_ACCEPTED (surface reconsent_modal); dismissal = viewed − accepted.
	RECONSENT_MODAL_VIEWED: 'reconsent_modal_viewed',
	// Se emite UNA VEZ POR DOCUMENTO cuando la aceptación quedó registrada, no
	// cuando el usuario palomeó: el check del alta firma varios documentos y lo
	// que interesa medir es lo que efectivamente quedó. Cierra el par con
	// `LEGAL_DOCUMENT_OPENED` —cuántos leen antes de firmar, que es lo que
	// pregunta legal— pero NO es la fuente de verdad del conteo: esa es la fila
	// de `compliance_log`, que guarda versión, IP y user-agent. Un evento de
	// front es lossy; la firma no.
	LEGAL_DOCUMENT_ACCEPTED: 'legal_document_accepted',
	CURP_EXTRACTION_TRIGGER_REQUESTED: 'curp_extraction_trigger_requested',
	CURP_EXTRACTION_SUCCEEDED: 'curp_extraction_succeeded',
	CURP_EXTRACTION_FAILED: 'curp_extraction_failed',
	//? Onboarding — Comunicado SAT AI analysis (SatNotificationsStep)
	COMUNICADO_ANALYSIS_STARTED: 'comunicado_analysis_started',
	COMUNICADO_ANALYSIS_COMPLETED: 'comunicado_analysis_completed',
	COMUNICADO_ANALYSIS_FAILED: 'comunicado_analysis_failed',
	COMUNICADO_VERDICT_ACTION_CLICKED: 'comunicado_verdict_action_clicked',
	//? Onboarding — Post-regularization plan upsell (PlanUpsellView)
	PLAN_UPSELL_VIEWED: 'plan_upsell_viewed',
	PLAN_UPSELL_ACCEPTED: 'plan_upsell_accepted',
	PLAN_UPSELL_DECLINED: 'plan_upsell_declined',
	//? Onboarding — Recommended plan card periodicity toggle (RecommendedPlanCard)
	PLAN_PERIODICITY_TOGGLED: 'plan_periodicity_toggled',
	//? Fiscal sync status banner (global top bar)
	FISCAL_BANNER_VIEWED: 'fiscal_banner_viewed',
	FISCAL_BANNER_OPENED: 'fiscal_banner_opened',
	// Lo que el usuario HACE dentro del drawer, no solo que lo abrió. Un solo
	// evento con `action_type` (patrón de `onboarding_step_interacted`) para no
	// partir la taxonomía en seis. Siempre estampa `fiscal_stage` y `summary_source`:
	// sin ellos no se puede separar al que llegó por CURP del que ya vinculó, que
	// es justo la pregunta que abre este drawer.
	FISCAL_DRAWER_INTERACTED: 'fiscal_drawer_interacted',
	//? Onboarding — Milestones screen
	MILESTONES_SCREEN_VIEWED: 'milestones_screen_viewed',
	MILESTONE_VIEWED: 'milestone_viewed',
	MILESTONE_CTA_CLICKED: 'milestone_cta_clicked',
	MILESTONE_COMPLETED: 'milestone_completed',
	DASHBOARD_VIEWED: 'dashboard_viewed',
	//? Backup paid signal — fires the first time we observe an active
	//? subscription / acquisition for a user via the subscription/
	//? acquisition fetch. Covers purchases where the Charged checkout-
	//? screen event was lost (browser closed mid-flow, webhook-only
	//? payment, cross-device, etc.). Idempotent per user via getStorage.
	PURCHASE_DETECTED: 'purchase_detected',
	//? Linking Flow
	LINKING: 'linking',
	//? Linking Flow — GTM-only step events
	GTM_LINKING_STEP_1_VIEWED: 'linking_step_1_viewed',
	GTM_LINKING_STEP_1_OPTION_CLICKED: 'linking_step_1_option_clicked',
	GTM_LINKING_STEP_2_VIEWED: 'linking_step_2_viewed',
	GTM_LINKING_STEP_2_SUBMITTED: 'linking_step_2_submitted',
	GTM_LINKING_STEP_2_FAILED: 'linking_step_2_failed',
	//? Product Interaction
	PRODUCT_INTERACTION_SHOPPING_CART: 'product_interaction_shopping_cart',
	//? Declarations
	PRODUCT_INTERACTION_DECLARATIONS: 'product_interaction_declarations',
	PAGE_VIEW_DECLARATIONS: 'declarations_page',
	//? Declaration Rating / CSAT
	CSAT_VIEWED: 'csat_viewed',
	CSAT_SUBMITTED: 'csat_submitted',
	CSAT_DISMISSED: 'csat_dismissed',
	CSAT_RATED: 'csat_rated',
	CSAT_FEEDBACK_TYPED: 'csat_feedback_typed',

	//? NPS (t-015): modal 0–10 del portal. La respuesta vive en users.nps
	//? (UME POST /nps/me); estos eventos miden el embudo del modal.
	NPS_VIEWED: 'nps_viewed',
	NPS_SCORED: 'nps_scored',
	NPS_SUBMITTED: 'nps_submitted',
	NPS_DISMISSED: 'nps_dismissed',
	//? Native review (App Store / Play Store) — disparados desde la app vía bridge
	NATIVE_REVIEW_PROMPT_REQUESTED: 'native_review_prompt_requested',
	NATIVE_REVIEW_PROMPT_COOLDOWN_BLOCKED: 'native_review_prompt_cooldown_blocked',
	//? Update prompt for old app versions (features/app-update, flag `app-update-wall`).
	//? All carry `mode`, `platform`, `app_version` ("unknown" without `window.HeruApp`) and `threshold`.
	APP_UPDATE_PROMPT_SHOWN: 'app_update_prompt_shown',
	APP_UPDATE_STORE_OPENED: 'app_update_store_opened',
	APP_UPDATE_PROMPT_DISMISSED: 'app_update_prompt_dismissed',
	//? Chat de soporte sobre Ágora (features/support-chat). `entry_point` dice de
	//? dónde se entró (`case` = la pestaña Mensajes de un caso del home); en la
	//? conversación de un caso del CRM llevan además `crm_issue_id`.
	//? `support_chat_opened` sale cuando carga el hilo, con lo que el usuario
	//? encontró: `message_count` (sin líneas de sistema) y `has_staff_message`.
	SUPPORT_CHAT_OPENED: 'support_chat_opened',
	SUPPORT_CHAT_MESSAGE_SENT: 'support_chat_message_sent',
	SUPPORT_CHAT_ATTACHMENT_FAILED: 'support_chat_attachment_failed',
	SUPPORT_CHAT_CONVERSATION_CLOSED: 'support_chat_conversation_closed',
	//? Lista de conversaciones de /support (solo con casos abiertos). `list_viewed`
	//? al mostrarse, con cuántas conversaciones y no leídos tiene; `list_conversation_selected`
	//? al elegir una (`conversation_kind`: general | ticket).
	SUPPORT_CHAT_LIST_VIEWED: 'support_chat_list_viewed',
	SUPPORT_CHAT_LIST_CONVERSATION_SELECTED: 'support_chat_list_conversation_selected',
	//? Post-link flow (3 pasos: Initiated → Interacted → Completed)
	POST_LINK_INITIATED: 'post_link_initiated',
	POST_LINK_STEP_INTERACTED: 'post_link_step_interacted',
	POST_LINK_SUCCESS_COMPLETED: 'post_link_success_completed',
	POST_LINK_FAILURE_IDENTIFIED: 'post_link_failure_identified',
	//? Checkout flow (Initiated → Step Interacted → Success/Failure)
	CHECKOUT_CART_ITEM_ADDED: 'checkout_cart_item_added',
	CHECKOUT_ADD_TO_CART_FAILED: 'checkout_add_to_cart_failed',
	CHECKOUT_INITIATED: 'checkout_initiated',
	CHECKOUT_STEP_INTERACTED: 'checkout_step_interacted',
	CHECKOUT_PAYMENT_FAILED: 'checkout_payment_failed',
	CHECKOUT_ABANDONED: 'checkout_abandoned',
	//? Ally compliance hub (onboarding-v3 ally-profile): one event, `action` is the axis
	//? (guided step started/completed/later/back/opened, requirement expanded/action,
	//? help WhatsApp, certificate download). The node view comes from onboarding_step_interacted.
	ALLY_HUB_INTERACTED: 'ally_hub_interacted',
	//? Regularization package builder (Viewed → Interacted → Submitted/Abandoned).
	//? Same four events on every surface that builds a back-declarations package;
	//? `source` is what tells them apart (planes, onboarding, deeplink, …).
	REGULARIZATION_BUILDER_VIEWED: 'regularization_builder_viewed',
	REGULARIZATION_BUILDER_INTERACTED: 'regularization_builder_interacted',
	REGULARIZATION_BUILDER_SUBMITTED: 'regularization_builder_submitted',
	REGULARIZATION_BUILDER_ABANDONED: 'regularization_builder_abandoned',
	//? Cancellation save-flow (Started → Reason → Offer Shown → Accepted/Declined → Completed)
	CANCEL_FLOW_STARTED: 'cancel_flow_started',
	CANCEL_REASON_SELECTED: 'cancel_reason_selected',
	CANCEL_OFFER_SHOWN: 'cancel_offer_shown',
	CANCEL_OFFER_ACCEPTED: 'cancel_offer_accepted',
	CANCEL_OFFER_DECLINED: 'cancel_offer_declined',
	CANCEL_COMPLETED: 'cancel_completed',
	//? Wrapped
	WRAPPED: 'wrapped',
	//? Payment Receipt & Line
	DECLARATION_DOCUMENT_PAID_INITIATED: 'declaration_document_paid_initiated',
	DECLARATION_DOCUMENT_PAID_REQUESTED: 'declaration_document_paid_requested',
	PAYMENT_LINE_INITIATED: 'payment_line_initiated',
	PAYMENT_LINE_REQUESTED: 'payment_line_requested',
	DECLARATIONS_PRODUCT_INTERATION: 'declarations_product_interation',
	ANNUAL_DECLARATION_PRODUCT_INTERACTION: 'annual_declaration_product_interaction',
	DECLARATIONS_ENTRY_INTERACTED: 'declarations_entry_interacted',
	DECLARATIONS_SURFACE_VIEWED: 'declarations_surface_viewed',
	//? Document viewer (ModalFrame)
	DOCUMENT_VIEWER_LOADED: 'document_viewer_loaded',
	DOCUMENT_VIEWER_FAILED: 'document_viewer_failed',
	//? Referrals
	// El denominador honesto del loop: `REFERRAL_CODE_INITIATED` se emite cuando
	// el código YA cargó, así que un fallo de carga se veía idéntico a que nadie
	// abrió el modal. `OPENED` mide la intención y `LOAD_FAILED` el borde.
	// Los dos primeros pasos del embudo emisor viven en el popup de bienvenida,
	// antes del modal. `referral_modal_opened` no distingue quién lo abrió
	// (topbar / deeplink / popup), así que la atribución del popup se lee como
	// funnel ORDENADO en Amplitude: popup_viewed → popup_cta_clicked →
	// referral_modal_opened → referral_code_shared.
	// El explicador de heru-cash que abre la franja del premio por vincular
	// (LinkingRewardBanner). `source` distingue la superficie que lo abrió
	// —legacy vs onboarding v3— porque son dos flujos con denominadores
	// distintos: v3 es por donde entra todo usuario nuevo.
	HERU_CASH_EXPLAINER_VIEWED: 'heru_cash_explainer_viewed',
	REFERRAL_POPUP_VIEWED: 'referral_popup_viewed',
	REFERRAL_POPUP_CTA_CLICKED: 'referral_popup_cta_clicked',
	REFERRAL_MODAL_OPENED: 'referral_modal_opened',
	REFERRAL_CODE_LOAD_FAILED: 'referral_code_load_failed',
	REFERRAL_CODE_INITIATED: 'referral_code_initiated',
	REFERRAL_CODE_SHARED: 'referral_code_shared',
	// Lado del referido: sin estos el loop viral solo se medía del lado de quien
	// comparte y el funnel de adquisición era invisible.
	REFERRAL_LINK_CLICKED: 'referral_link_clicked',
	REFERRAL_CREDITS_APPLIED: 'referral_credits_applied',
	REFERRAL_CREDITS_REMOVED: 'referral_credits_removed',
	//? Fiscal Advisor (Call of Plans) — A/B test
	FISCAL_ADVISOR_VIEWED: 'fiscal_advisor_viewed',
	FISCAL_ADVISOR_DIAGNOSIS_SHOWN: 'fiscal_advisor_diagnosis_shown',
	FISCAL_ADVISOR_ANALYSIS_DRAWER_OPENED: 'fiscal_advisor_analysis_drawer_opened',
	FISCAL_ADVISOR_ANALYSIS_AGREED: 'fiscal_advisor_analysis_agreed',
	FISCAL_ADVISOR_ANALYSIS_CONTACT_SUPPORT: 'fiscal_advisor_analysis_contact_support',
	FISCAL_ADVISOR_ANALYSIS_DISMISSED: 'fiscal_advisor_analysis_dismissed',
	FISCAL_ADVISOR_CHECKOUT_ALL: 'fiscal_advisor_checkout_all',
	FISCAL_ADVISOR_CHECKOUT_YEAR: 'fiscal_advisor_checkout_year',
	FISCAL_ADVISOR_PERIODICITY_TOGGLED: 'fiscal_advisor_periodicity_toggled',
	FISCAL_ADVISOR_PLAN_CTA_CLICKED: 'fiscal_advisor_plan_cta_clicked',
	FISCAL_ADVISOR_SAT_ACTION_CLICKED: 'fiscal_advisor_sat_action_clicked',
	FISCAL_ADVISOR_CONTACT_SUPPORT_CLICKED: 'fiscal_advisor_contact_support_clicked',
	FISCAL_ADVISOR_OPTIONAL_STEP_EXPANDED: 'fiscal_advisor_optional_step_expanded',
	FISCAL_ADVISOR_OPTIONAL_STEP_ACTION: 'fiscal_advisor_optional_step_action',
	FISCAL_ADVISOR_OPTIONAL_STEP_SKIPPED: 'fiscal_advisor_optional_step_skipped',
	FISCAL_ADVISOR_TEASER_SHOWN: 'fiscal_advisor_teaser_shown',
	FISCAL_ADVISOR_ESCAPE_TO_REGULARIZATION_CLICKED: 'fiscal_advisor_escape_to_regularization_clicked',
	FISCAL_ADVISOR_SELECT_ALL_CLICKED: 'fiscal_advisor_select_all_clicked',
	FISCAL_ADVISOR_MSI_TAG_SHOWN: 'fiscal_advisor_msi_tag_shown',
	FISCAL_ADVISOR_LINK_INTRO_SHOWN: 'fiscal_advisor_link_intro_shown',
	FISCAL_ADVISOR_LINK_INTRO_CONTINUE_CLICKED: 'fiscal_advisor_link_intro_continue_clicked',
	FISCAL_ADVISOR_CREDENTIALS_SHOWN: 'fiscal_advisor_credentials_shown',
	FISCAL_ADVISOR_CREDENTIALS_FAQ_OPENED: 'fiscal_advisor_credentials_faq_opened',
	FISCAL_ADVISOR_LINK_CTA_CLICKED: 'fiscal_advisor_link_cta_clicked',
	FISCAL_ADVISOR_ASAT_HELP_CLICKED: 'fiscal_advisor_asat_help_clicked',
	FISCAL_ADVISOR_ASAT_VIEW_SHOWN: 'fiscal_advisor_asat_view_shown',
	FISCAL_ADVISOR_ASAT_OPTION_TOGGLED: 'fiscal_advisor_asat_option_toggled',
	FISCAL_ADVISOR_ASAT_REQUESTED: 'fiscal_advisor_asat_requested',
	FISCAL_ADVISOR_SYNC_VIEW_SHOWN: 'fiscal_advisor_sync_view_shown',
	FISCAL_ADVISOR_HANDOFF_TRIGGERED: 'fiscal_advisor_handoff_triggered',
	//? Home shell — quick actions row (QuickActions widget)
	HOME_QUICK_ACTION_CLICKED: 'home_quick_action_clicked',
	PLAN_RECOMMENDED_DRAWER_OPENED: 'plan_recommended_drawer_opened',
	//? Planes (/plans) — catálogo de planes
	PLAN_CATEGORY_SELECTED: 'plan_category_selected',
	PLAN_DETAILS_EXPANDED: 'plan_details_expanded',
	// Eligió un plan que no cubre su régimen: se le avisó y `action` dice qué
	// hizo (siguió, cambió al recomendado o cerró el aviso).
	PLAN_REGIME_MISMATCH: 'plan_regime_mismatch',
	PLAN_ACTIVE_DETAIL_OPENED: 'plan_active_detail_opened',
	//? Cambio de plan en la misma suscripción (t-298). El hecho vive server-side
	//? (subscription_plan_change y `subscription_plan_changed` del motor): estos
	//? son el funnel. `entry` dice desde qué pantalla se abrió.
	// Vio la cotización: `outcome` dice si cobra, da heru-cash, es gratis o se programa.
	PLAN_CHANGE_QUOTE_VIEWED: 'plan_change_quote_viewed',
	// El cambio quedó: `settled` es applied, scheduled o paid_pending (pagó y el motor aún no lo aplica).
	PLAN_CHANGE_CONFIRMED: 'plan_change_confirmed',
	// No quedó: `stage` (confirm o payment) y `error_code` (el motivo del rechazo o del banco).
	PLAN_CHANGE_FAILED: 'plan_change_failed',
	// Asked to change to another plan: the request went to the user's general chat
	// (`channel`). `entry_point` says from where, `conversation_opened` whether the
	// user was taken into the chat. `plan_change_request_fell_back` is the request failing and the
	// surface falling back (`fallback`: the old change-plan email or the chat draft).
	PLAN_CHANGE_REQUESTED: 'plan_change_requested',
	PLAN_CHANGE_REQUEST_FELL_BACK: 'plan_change_request_fell_back',
	//? Experimento del plan recomendado (/plans, drawer del inicio, onboarding):
	//? la experiencia de hoy contra la nueva (tarjeta guiada y test de plan).
	//? Solo los emite usePlanRecommendationEvents. La exposición y la compra
	//? viven server-side (user_experiments y el carrito): estos son el funnel.
	// Vista del brazo en los dos brazos; `layout` dice qué experiencia vio.
	PLAN_RECOMMENDATION_VIEWED: 'plan_recommendation_viewed',
	PLAN_GUIDED_ACTIVATE_CLICKED: 'plan_guided_activate_clicked',
	// Abrió o cerró «Ver otros planes» (o «Ver todos los planes» sin plan recomendado).
	PLAN_OTHER_PLANS_TOGGLED: 'plan_other_plans_toggled',
	PLAN_FIT_QUIZ_STARTED: 'plan_fit_quiz_started',
	// Cada pantalla del test que se pinta, con la anterior: el funnel por paso,
	// incluido el camino de la CURP (la dio, la saltó, qué respondió el SAT).
	PLAN_FIT_QUIZ_STEP_VIEWED: 'plan_fit_quiz_step_viewed',
	PLAN_FIT_QUIZ_QUESTION_ANSWERED: 'plan_fit_quiz_question_answered',
	PLAN_FIT_QUIZ_RESULT_VIEWED: 'plan_fit_quiz_result_viewed',
	PLAN_FIT_QUIZ_RESULT_CTA_CLICKED: 'plan_fit_quiz_result_cta_clicked',
	// Cerró el test sin contratar; `step` es la pantalla en la que lo dejó.
	PLAN_FIT_QUIZ_CLOSED: 'plan_fit_quiz_closed',
	//? Tour post-compra (SuccessfulPurchase/tour). El NÚMERO de compras y las
	//? respuestas del cuestionario viven server-side (carrito y
	//? onboarding.answers): estos eventos son el funnel y el drop-off por slide.
	PURCHASE_TOUR_STARTED: 'purchase_tour_started',
	PURCHASE_TOUR_SCREEN_VIEWED: 'purchase_tour_screen_viewed',
	PURCHASE_TOUR_QUESTION_ANSWERED: 'purchase_tour_question_answered',
	PURCHASE_TOUR_NEXT_STEP_CLICKED: 'purchase_tour_next_step_clicked',
	PURCHASE_TOUR_COMPLETED: 'purchase_tour_completed',
	PURCHASE_TOUR_EXITED: 'purchase_tour_exited',
	//? Facturación v2 · tours guiados (shared/tour). Props: tour_id, tour_version,
	//? step (id del ancla), step_index (desde 1, el que ve el usuario),
	//? total_steps; dismissed agrega action: later | close.
	INVOICE_V2_TOUR_STEP_VIEWED: 'invoice_v2_tour_step_viewed',
	INVOICE_V2_TOUR_COMPLETED: 'invoice_v2_tour_completed',
	INVOICE_V2_TOUR_DISMISSED: 'invoice_v2_tour_dismissed',
	//? Novedades de la navegación (shell/nav/novelties.ts). Todos llevan
	//? novelty_id y surface: sidebar | mobile. cta_clicked sale del CTA de la
	//? tarjeta o del clic en la entrada; opened agrega via: auto | hover | focus |
	//? click (auto = la tarjeta se abrió sola, una vez); closed agrega via:
	//? ahora_no | esc | outside | mouseleave; expired agrega reason: first_click |
	//? ttl_14d.
	SIDEBAR_NOVELTY_SHOWN: 'sidebar_novelty_shown',
	SIDEBAR_NOVELTY_OPENED: 'sidebar_novelty_opened',
	SIDEBAR_NOVELTY_CTA_CLICKED: 'sidebar_novelty_cta_clicked',
	SIDEBAR_NOVELTY_CLOSED: 'sidebar_novelty_closed',
	SIDEBAR_NOVELTY_EXPIRED: 'sidebar_novelty_expired',
	//? Detalle de una compra ya hecha (recibo reabierto)
	PURCHASE_DETAIL_OPENED: 'purchase_detail_opened',
	/** Anuncio del primer mes gratis en onboarding (experimento
	 * `first-month-free-announce`). Un solo nombre, diferenciado por `action`:
	 * `shown` es la impresión real de la franja —el denominador del banner, que
	 * NO es el mismo que el de la asignación— y `clicked` la apertura del
	 * drawer. Lleva `variant` (la ventana asignada) para poder cortar por brazo
	 * sin unir contra el stamp. */
	FIRST_MONTH_FREE_PROMO: 'first_month_free_promo',
	/** Home banner of a Zubale partner with their Zubale compliance status. One
	 * name split by `action`, like FIRST_MONTH_FREE_PROMO: `shown` is the real
	 * impression (once per `step`; the bar may be held by a fiscal notice) and
	 * `clicked` the tap. `step` is the status shown (enroll | link_sat |
	 * upload_efirma | rfc_attention | upload_sellos | sellos_expired | sellos_overdue |
	 * regime_mismatch | sellos_waiting | ready), `variant` its tone (info |
	 * warning | success) and `source` the surface (home). */
	ZUBALE_STATUS_BANNER: 'zubale_status_banner',
	PURCHASE_RECEIPT_DOWNLOADED: 'purchase_receipt_downloaded',
	//? Detector de versión en modo sombra — reporta bundles viejos, no recarga
	APP_VERSION_STALE_DETECTED: 'app_version_stale_detected',
	//? Mobile bottom bar and its menu: same names and properties as the native app
	APP_NAV_TAB_TAPPED: 'app_nav_tab_tapped',
	APP_MENU_OPENED: 'app_menu_opened',
	APP_MENU_ITEM_TAPPED: 'app_menu_item_tapped',
	APP_MENU_DISMISSED: 'app_menu_dismissed',
	//? Nueva vista de Declaraciones (features/declarations-new): macros del embudo
	DECLARATIONS_VIEWED: 'declarations_viewed',
	DECLARATIONS_PERIOD_OPENED: 'declarations_period_opened',
	DECLARATIONS_REVIEW_STARTED: 'declarations_review_started',
	DECLARATIONS_APPROVED: 'declarations_approved',
	DECLARATIONS_OBJECTED: 'declarations_objected',
	DECLARATIONS_CAPTURE_LINE_REQUESTED: 'declarations_capture_line_requested',
	DECLARATIONS_CAPTURE_LINE_COPIED: 'declarations_capture_line_copied',
	DECLARATIONS_PAYMENT_REPORTED: 'declarations_payment_reported',
	DECLARATIONS_CASH_ANSWERED: 'declarations_cash_answered',
	DECLARATIONS_ANNUAL_OPENED: 'declarations_annual_opened',
	DECLARATIONS_ANNUAL_PURCHASE_CLICKED: 'declarations_annual_purchase_clicked',
	CAMPAIGN_BANNER: 'campaign_banner',
	DECLARATIONS_CATCH_UP_CLICKED: 'declarations_catch_up_clicked',
	DECLARATIONS_HELP_REQUESTED: 'declarations_help_requested',
	DECLARATIONS_ACTION_FAILED: 'declarations_action_failed',
	//? Nueva vista de Declaraciones: micros (qué se usa y qué no)
	DECLARATIONS_ELEMENT_CLICKED: 'declarations_element_clicked',
	DECLARATIONS_SECTION_TOGGLED: 'declarations_section_toggled',
	DECLARATIONS_LAYOUT_SWITCHED: 'declarations_layout_switched',
	DECLARATIONS_YEAR_CHANGED: 'declarations_year_changed',
	DECLARATIONS_REGIME_SWITCHED: 'declarations_regime_switched',
	DECLARATIONS_MOVEMENT_OPENED: 'declarations_movement_opened',
	DECLARATIONS_DEDUCTION_CHANGED: 'declarations_deduction_changed',
	DECLARATIONS_DOCUMENT_OPENED: 'declarations_document_opened',
	DECLARATIONS_DOCUMENT_SAVED: 'declarations_document_saved',
	DECLARATIONS_FAQ_OPENED: 'declarations_faq_opened',
	DECLARATIONS_ACTIVITY_ITEM_CLICKED: 'declarations_activity_item_clicked',
	DECLARATIONS_PAYROLL_RECEIPT_OPENED: 'declarations_payroll_receipt_opened',
	DECLARATIONS_REFUND_VIEWED: 'declarations_refund_viewed',
	DECLARATIONS_REFUND_SCREEN_VIEWED: 'declarations_refund_screen_viewed',
	DECLARATIONS_REFUND_OPTION_SELECTED: 'declarations_refund_option_selected',
	DECLARATIONS_REFUND_STATEMENT_UPLOADED: 'declarations_refund_statement_uploaded',
	DECLARATIONS_REFUND_CHOICE_SENT: 'declarations_refund_choice_sent',
	DECLARATIONS_DEDUCTIONS_VIEWED: 'declarations_deductions_viewed',
	DECLARATIONS_HERU_SEAL_HOVERED: 'declarations_heru_seal_hovered',
	DECLARATIONS_HERU_SEAL_CLICKED: 'declarations_heru_seal_clicked',
	DECLARATIONS_CTA_CLICKED: 'declarations_cta_clicked',
	DECLARATIONS_PURCHASE_CLICKED: 'declarations_purchase_clicked',
	DECLARATIONS_RENEWAL_ADVANCED: 'declarations_renewal_advanced',
	DECLARATIONS_LOAD_FAILED: 'declarations_load_failed',
	DECLARATIONS_OBJECTION_CANCELLED: 'declarations_objection_cancelled',
	DECLARATIONS_SAT_RECONNECTED: 'declarations_sat_reconnected',
	DECLARATIONS_FILTER_CHANGED: 'declarations_filter_changed',
	DECLARATIONS_INVOICE_PAGED: 'declarations_invoice_paged',
	DECLARATIONS_ACTIVITY_LOADED_MORE: 'declarations_activity_loaded_more',
	DECLARATIONS_FIELD_STARTED: 'declarations_field_started',
	DECLARATIONS_SCREEN_LEFT: 'declarations_screen_left',
	DECLARATIONS_SECTION_VIEWED: 'declarations_section_viewed',
	DECLARATIONS_DOCUMENT_CLOSED: 'declarations_document_closed',
	DECLARATIONS_DEEPLINK_OPENED: 'declarations_deeplink_opened',
	DECLARATIONS_INTRO_SCREEN_VIEWED: 'declarations_intro_screen_viewed',
	DECLARATIONS_INTRO_COMPLETED: 'declarations_intro_completed',
	DECLARATIONS_INTRO_SKIPPED: 'declarations_intro_skipped',
	DECLARATIONS_INTRO_STEP_COMPLETED: 'declarations_intro_step_completed',
	DECLARATIONS_GUIDE_STEP_VIEWED: 'declarations_guide_step_viewed',
	DECLARATIONS_GUIDE_COMPLETED: 'declarations_guide_completed',
	DECLARATIONS_GUIDE_SKIPPED: 'declarations_guide_skipped',
	DECLARATIONS_GUIDE_STEP_COMPLETED: 'declarations_guide_step_completed',
	DECLARATIONS_PRESENTATION_ASKED: 'declarations_presentation_asked',
	DECLARATIONS_PRESENTATION_CHOSEN: 'declarations_presentation_chosen',
	DECLARATIONS_PRESENTATION_DEFERRED: 'declarations_presentation_deferred',
	//? Facturación v2 (/facturacion) e invoice-qr v2. Namespace propio: el legacy
	//? conserva invoicing_* e invoice_qr_*. Solo intentos y pantallas: los hechos
	//? (invoice_v2_stamped, _stamp_failed, _csd_registered, _qr_published,
	//? _qr_request_created/_invoiced/_rejected/_expired) los emite heru-fiscal-engine.
	//? Excepción: invoice_v2_csd_removed, porque la baja del sello no deja rastro en el servidor.
	//? Se disparan desde useInvoiceV2Tracking, nunca sueltos.
	INVOICE_V2_HOME_VIEWED: 'invoice_v2_home_viewed',
	INVOICE_V2_FLOW_STARTED: 'invoice_v2_flow_started',
	INVOICE_V2_STEP_VIEWED: 'invoice_v2_step_viewed',
	INVOICE_V2_STAMP_REQUESTED: 'invoice_v2_stamp_requested',
	INVOICE_V2_CSD_REMOVED: 'invoice_v2_csd_removed',
	INVOICE_V2_CSD_ACTIVATION_PENDING_SHOWN: 'invoice_v2_csd_activation_pending_shown',
	INVOICE_V2_FILE_DOWNLOADED: 'invoice_v2_file_downloaded',
	//? Escena del timbrado y pantalla de éxito: la espera lenta que se vio, lo que se
	//? hizo con la factura (ver, compartir, copiar el folio, facturar otra) y el podio.
	INVOICE_V2_STAMP_SLOW_SHOWN: 'invoice_v2_stamp_slow_shown',
	INVOICE_V2_STAMPED_ACTION: 'invoice_v2_stamped_action',
	INVOICE_V2_PODIUM_OPENED: 'invoice_v2_podium_opened',
	INVOICE_V2_ASSISTANT_OPENED: 'invoice_v2_assistant_opened',
	INVOICE_V2_ASSISTANT_DRAFT_APPLIED: 'invoice_v2_assistant_draft_applied',
	INVOICE_V2_EXCHANGE_RATE_PREFILLED: 'invoice_v2_exchange_rate_prefilled',
	INVOICE_V2_EXCHANGE_RATE_OVERRIDDEN: 'invoice_v2_exchange_rate_overridden',
	INVOICE_V2_EXCHANGE_RATE_UNAVAILABLE: 'invoice_v2_exchange_rate_unavailable',
	INVOICE_V2_PREVIEW_OPENED: 'invoice_v2_preview_opened',
	INVOICE_V2_ISSUER_REGIME_CHANGED: 'invoice_v2_issuer_regime_changed',
	INVOICE_V2_ISSUER_POSTAL_CODE_CHANGED: 'invoice_v2_issuer_postal_code_changed',
	INVOICE_V2_RETENTION_OVERRIDE_CHANGED: 'invoice_v2_retention_override_changed',
	INVOICE_V2_RETENTION_RATE_CAPTURED: 'invoice_v2_retention_rate_captured',
	INVOICE_V2_RECEPTOR_SUGGESTED_SAVED: 'invoice_v2_receptor_suggested_saved',
	INVOICE_V2_QR_DASHBOARD_VIEWED: 'invoice_v2_qr_dashboard_viewed',
	INVOICE_V2_QR_SHARED: 'invoice_v2_qr_shared',
	INVOICE_V2_QR_SHOW_QR: 'invoice_v2_qr_show_qr',
	INVOICE_V2_QR_VIDEO_OPENED: 'invoice_v2_qr_video_opened',
	INVOICE_V2_QR_REQUESTS_VIEWED: 'invoice_v2_qr_requests_viewed',
	INVOICE_V2_QR_REQUEST_OPENED: 'invoice_v2_qr_request_opened',
	INVOICE_V2_QR_REQUEST_EDITED: 'invoice_v2_qr_request_edited',
	INVOICE_V2_QR_REQUESTS_TAB_CHANGED: 'invoice_v2_qr_requests_tab_changed',
	INVOICE_V2_QR_INCOME_MONTH_SELECTED: 'invoice_v2_qr_income_month_selected',
	INVOICE_V2_QR_MAINTENANCE_VIEWED: 'invoice_v2_qr_maintenance_viewed',
	//? Página pública del QR (anónima): solo Amplitude, llave public_id/slug.
	INVOICE_V2_QR_PUBLIC_VIEWED: 'invoice_v2_qr_public_viewed',
	INVOICE_V2_QR_REQUEST_SUBMITTED: 'invoice_v2_qr_request_submitted',
	INVOICE_V2_QR_REQUEST_SUBMIT_FAILED: 'invoice_v2_qr_request_submit_failed',
	INVOICE_V2_QR_RECEIPT_VIEWED: 'invoice_v2_qr_receipt_viewed',
	INVOICE_V2_QR_FISCAL_VALIDATION: 'invoice_v2_qr_fiscal_validation',
	INVOICE_V2_QR_RECEIPT_DOWNLOADED: 'invoice_v2_qr_receipt_downloaded',
	INVOICE_V2_QR_HERU_CTA_CLICKED: 'invoice_v2_qr_heru_cta_clicked',
	//? «Mis facturas» de /facturacion: el acceso, la lista, el detalle, sus archivos y la cancelación.
	//? La cancelación lleva su resultado desde el front porque el NestJS no
	//? registra los intentos fallidos (mismo motivo que invoicing_cancel_*).
	INVOICE_V2_MY_INVOICES_CLICKED: 'invoice_v2_my_invoices_clicked',
	INVOICE_V2_PERIOD_FILTER_CHANGED: 'invoice_v2_period_filter_changed',
	INVOICE_V2_LEGACY_REDIRECT_STUCK: 'invoice_v2_legacy_redirect_stuck',
	INVOICE_V2_MY_INVOICES_TAB_CHANGED: 'invoice_v2_my_invoices_tab_changed',
	INVOICE_V2_MY_INVOICES_MONTH_SELECTED: 'invoice_v2_my_invoices_month_selected',
	INVOICE_V2_MY_INVOICES_DOCUMENT_OPENED: 'invoice_v2_my_invoices_document_opened',
	INVOICE_V2_INVOICE_OPENED: 'invoice_v2_invoice_opened',
	INVOICE_V2_CANCEL_REQUESTED: 'invoice_v2_cancel_requested',
	INVOICE_V2_CANCEL_SUCCEEDED: 'invoice_v2_cancel_succeeded',
	INVOICE_V2_CANCEL_FAILED: 'invoice_v2_cancel_failed',
	//? Complemento de pago en la facturación nueva. Intentos y pantallas; el hecho es la fila de public.invoice_payment.
	INVOICE_V2_PAYMENT_STARTED: 'invoice_v2_payment_started',
	INVOICE_V2_PAYMENT_STEP_VIEWED: 'invoice_v2_payment_step_viewed',
	INVOICE_V2_PAYMENT_STAMP_REQUESTED: 'invoice_v2_payment_stamp_requested',
	INVOICE_V2_PAYMENT_STAMP_RESULT: 'invoice_v2_payment_stamp_result',
	//? Cobro por cupo de la facturación: el funnel de quien se topa con su límite.
	//? Los hechos viven en el servidor: el rechazo en invoiceplan.quota_rejection
	//? (invoicing_service) y la compra en la suscripción de plans_service.
	INVOICE_QUOTA_PAYWALL_SHOWN: 'invoice_quota_paywall_shown',
	INVOICE_PLAN_STATUS_OPENED: 'invoice_plan_status_opened',
	INVOICE_PLAN_UPGRADE_CLICKED: 'invoice_plan_upgrade_clicked',
	//? Marca propia en el PDF de las facturas (/facturacion/marca). Pantalla e intentos; el
	//? hecho es la fila de pdfbrand.brand_change (invoicing_service) y el uso, la prop
	//? pdf_brand de invoice_v2_stamped, que emite heru-fiscal-engine.
	INVOICE_V2_PDF_BRAND_VIEWED: 'invoice_v2_pdf_brand_viewed',
	INVOICE_V2_PDF_BRAND_LOGO_UPLOADED: 'invoice_v2_pdf_brand_logo_uploaded',
	INVOICE_V2_PDF_BRAND_PREVIEW_OPENED: 'invoice_v2_pdf_brand_preview_opened',
	INVOICE_V2_PDF_BRAND_SAVED: 'invoice_v2_pdf_brand_saved',
	INVOICE_V2_PDF_BRAND_RESET: 'invoice_v2_pdf_brand_reset',
	//? Tarjeta del home (features/delivery-cycle): primeros pasos y los issues del
	//? CRM (ASAT y custom). `home_card_viewed` sale cuando la tarjeta entra en
	//? pantalla; `home_card_interacted` en cada toque, con su `action`. La
	//? conversación de un caso se mide con los `support_chat_*`.
	HOME_CARD_VIEWED: 'home_card_viewed',
	HOME_CARD_INTERACTED: 'home_card_interacted',
	PLATFORMS_WIDGET_VIEWED: 'platforms_widget_viewed',
	PLATFORMS_WIDGET_CLICKED: 'platforms_widget_clicked',
	PLATFORM_CERTIFICATES_VIEWED: 'platform_certificates_viewed',
	PLATFORM_CERTIFICATES_LOAD_FAILED: 'platform_certificates_load_failed',
	PLATFORM_CERTIFICATES_FILTER_CHANGED: 'platform_certificates_filter_changed',
	PLATFORM_CERTIFICATE_OPENED: 'platform_certificate_opened',
	PLATFORM_CERTIFICATES_PLAN_CLICKED: 'platform_certificates_plan_clicked',
};
